// idemGO wordmark + fingerprint mark. Single source of truth so the brand
// stays consistent across landing, auth pages, dashboard chrome and the
// public verification flow. The SVG is loaded as an asset URL (CRA handles
// hashing + caching) so callers can pick whichever invert/size they need.
import React from 'react';
import logoUrl from '../assets/idemgo-logo.svg';

// `mark` = just the fingerprint symbol (used inside small black tiles).
// `invert` flips the black SVG to white via a CSS filter so we can place
// it on dark backgrounds without shipping a second asset.
export function LogoMark({ size = 24, invert = false, className = '' }) {
  return (
    <img
      src={logoUrl}
      alt="idemGO"
      width={size}
      height={size}
      className={className}
      style={{
        objectFit: 'contain',
        filter: invert ? 'brightness(0) invert(1)' : 'none',
      }}
      data-testid="idemgo-logo-mark"
    />
  );
}

// Wordmark: tile + "idemGO" text. Drop-in replacement for the previous
// `<span className="w-6 h-6 bg-black ...">` snippet used on every header.
export function Logo({ tile = true, textClassName = 'font-display font-bold' }) {
  if (!tile) {
    return (
      <span className="flex items-center gap-2">
        <LogoMark size={25} />
        <span className={textClassName}>idemGO</span>
      </span>
    );
  }
  return (
    <span className="flex items-center gap-2">
      <span className="w-6 h-6 bg-black flex items-center justify-center rounded-sm">
        <LogoMark size={16} invert />
      </span>
      <span className={textClassName}>idemGO</span>
    </span>
  );
}
